import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { XcontestTitle } from 'src/components/Global/Text/TitleText'
import {
  InvestmentOption,
  ToggleWrapper,
} from 'src/components/Investment/Matured/maturedStyle'
import SEO from 'src/seo'
import AllContest from './All Contest/AllContest'
import MyContest from './MyContest/MyContest'
import { XcontestWrapper } from './style'
import TabComponent from '../Global/Tabs/Tab'
import { Wrap } from 'src/components/Investment/Matured/maturedStyle'
const tabs = [
  {
    name: 'All Contest',
    key: 'all',
    component: <AllContest />,
  },
  {
    name: 'Joined Contest',
    key: 'joined',
    component: <MyContest />,
  },
]

const Xcontest = () => {
  let location = useLocation()
  const [activeTab, setActiveTab] = useState(tabs[0].key)

  return (
    <XcontestWrapper>
      <SEO title="X-Contest" />
      <XcontestTitle> X - contest</XcontestTitle>
      <Wrap>
        <TabComponent
          tabs={tabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />

        <div className={'content active-content'}>
          {tabs.map((tab) => {
            return tab.key === activeTab ? tab.component : null
          })}
        </div>
      </Wrap>
    </XcontestWrapper>
  )
}

export default Xcontest
